import script from "./BaseOrganizationChart.vue?vue&type=script&lang=js"
export * from "./BaseOrganizationChart.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__